export const translations = {
  bg: {
    // Fold component
    confirmBtn: "ПОТВЪРДИ",
    confirmBtnMobile: "ПРИСЪСТВИЕ",
    dearGuests: "Скъпи гости,",
    we: "ние,",
    brideName: "НЕЛИ",
    groomName: "АНГЕЛ",
    invitationLead:
      'след безброй пътувания, хиляди споделени утрини с кафе, стотици "няма ли да се жените вече", най-сетне казваме заветното ',
    invitationYes: '"ДA"',
    invitationAfterYes: "! ",
    invitationQuestion: "Май беше време, нали?",
    invitationCelebrate:
      "Ще се радваме да отпразнуваме този ден с най-близките си хора ",
    invitationWithYou: " - с Вас.",
    day: "05",
    month: "септември",
    year: "2026",
    villaLocation: "ВИЛА СИНТИКА, САНДАНСКИ",
    country: "БЪЛГАРИЯ",

    // Content component
    program: "ПРОГРАМА",
    withLove: "с обич:",
    coupleNames: "Нели и Ачката",
    copyright: "Copyright ©2026 Сватбена покана",
    author: "Автор: Булката",

    // DetailsSection component
    details: "ДЕТАЙЛИ",
    accommodation: "НАСТАНЯВАНЕ",
    accommodationSubtitle: "Това е наша грижа!",
    accommodationTextLead:
      "За да споделим още повече време заедно и да се насладим на празника без грижи, с радост ви уведомяваме, че ",
    accommodationTextBold:
      'настаняването във "Вила Синтика" е наш подарък към Вас.',
    accommodationTextAfter:
      "Настаняването ще бъде възможно от 14:00 часа на 05.09.2026 г. Молим ви при пристигане да се регистрирате на рецепцията, където ще получите информация за вашата стая.",
    dressCode: "ДРЕСКОД",
    dressCodeSubtitle: "Официално",
    dressCodeNote: "...нека не ядосваме Булката в този ден! xD",
    gifts: "ПОДАРЪЦИ",
    giftsSubtitle:
      "Вместо цветя, бихме се радвали на вашето присъствие, то е най-ценният подарък за нас!",
    giftsNoteLead:
      "Ако желаете да ни зарадвате и по друг начин, можете да сложите подаръка в пликче или за ваше удобство -  ",
    giftsNoteLink: "сканирайте Revolut QR кода",
    giftsNoteEnd: ".",
    bestPeople: "КУМОВЕ",
    bestPeopleSubtitle: "За Кумството ще се погрижат Вяра и Стефан",

    // Transport component
    locationLabel: "ЛОКАЦИЯ:",
    mapNote: '(Кликни "Open in Maps", за да отвориш)',

    // Schedule component
    scheduleLocationLabel: "локация",
    villaName: 'вила “Синтика”',
    scheduleDate1: "05.09.2026г.",
    scheduleDate2: "06.09.2026г.",
    scheduleCheckIn: "настаняване",
    scheduleGathering: "събиране във вила на младоженеца",
    scheduleCeremony: "церемония",
    scheduleDinner: "вечеря",
    scheduleBreakfast: "закуска",
    scheduleCheckout: "освобождаване",

    // Counter component
    remaining: "ОСТАВАТ",
    days: "ДНИ",
    hours: "ЧАСА",
    minutes: "МИН.",
    seconds: "СЕК.",
    timeHasCome: "НАСТАНА ВРЕМЕ!",
    confirmByDate: "до 15 Юли, 2026г.",

    // ConfirmationContainer component
    confirmTitle: "ПОТВЪРДИ ПРИСЪСТВИЕ",
    confirmTextLead: "Молим да потвърдите присъствието си до ",
    deadline: "15 Юли, 2026г.",
    confirmAnother: "Искаш да потвърдиш за друг гост?",
    addGuest: "ДОБАВИ ГОСТ",

    // ConfirmForm component
    firstName: "Име*",
    lastName: "Фамилия*",
    email: "Имейл",
    canYouAttend: "Ще можеш ли да присъстваш?*",
    yes: "Да",
    noSorry: "Не, съжалявам",
    menuChoice: "Избор на меню*",
    meatOption: "Месно (пилешко)",
    vegOption: "Вегетарианско",
    kidsOption: "Детско",
    allergyQuestion: "Имаш ли алергия към дадена храна?",
    allergyYes: "Да, имам",
    allergyNo: "Не",
    allergyFood: "Коя е опасната храна?",
    submit: "ИЗПРАТИ",
    thankYou: "Благодарим за отделеното време.",
    confirmedSuccess: "успешно потвърди присъствието си на нашата сватба :) ",
    blackMark: "получи черна точка ;/ ",
    alertMissing: "Упс, май забрави да попълниш нещо?",
    alertError:
      "Възникна грешка. Моля опитайте пак или се свържете с нас, за да я поправим!",
  },

  en: {
    isEnglish: true,
    // Fold component
    confirmBtn: "CONFIRM",
    confirmBtnMobile: "ATTENDANCE",
    dearGuests: "Dear guests,",
    we: "we,",
    brideName: "NELLY",
    groomName: "ANGEL",
    invitationLead:
      'after countless trips, thousands of shared morning coffees, and hundreds of "when are you finally getting married", we are at last saying the long-awaited ',
    invitationYes: '"I DO"',
    invitationAfterYes: "! ",
    invitationQuestion: "About time, right?",
    invitationCelebrate:
      "We would love to celebrate this day with the people closest to us ",
    invitationWithYou: " - with you.",
    day: "05",
    month: "September",
    year: "2026",
    villaLocation: "VILLA SINTICA, SANDANSKI",
    country: "BULGARIA",

    // Content component
    program: "SCHEDULE",
    withLove: "with love:",
    coupleNames: "Nelly & Achkata",
    copyright: "Copyright ©2026 Wedding Invitation",
    author: "Created by: The Bride",

    // DetailsSection component
    details: "DETAILS",
    accommodation: "ACCOMMODATION",
    accommodationSubtitle: "That's on us!",
    accommodationTextLead:
      "So that we can share even more time together and enjoy the celebration without any worries, we are happy to let you know that ",
    accommodationTextBold:
      'your stay at "Villa Sintica" is our gift to you.',
    accommodationTextAfter:
      "Check-in will be available from 2:00 PM on 05.09.2026. Upon arrival, please register at the reception, where you will receive information about your room.",
    dressCode: "DRESS CODE",
    dressCodeSubtitle: "Formal",
    dressCodeNote: "...let's not upset the Bride on this day! xD",
    gifts: "GIFTS",
    giftsSubtitle:
      "Instead of flowers, we would be delighted by your presence — it is the most precious gift for us!",
    giftsNoteLead:
      "If you would like to make us happy in another way, you can place your gift in an envelope or, for your convenience -  ",
    giftsNoteLink: "scan the Revolut QR code",
    giftsNoteEnd: ".",
    bestPeople: "BEST MAN & MAID OF HONOR",
    bestPeopleSubtitle: "Vyara and Stefan will be our witnesses",

    // Transport component
    locationLabel: "LOCATION:",
    mapNote: '(Click "Open in Maps" to open)',

    // Schedule component
    scheduleLocationLabel: "location",
    villaName: 'Villa “Sintica”',
    scheduleDate1: "05.09.2026",
    scheduleDate2: "06.09.2026",
    scheduleCheckIn: "check-in",
    scheduleGathering: "gathering at the groom's villa",
    scheduleCeremony: "ceremony",
    scheduleDinner: "dinner",
    scheduleBreakfast: "breakfast",
    scheduleCheckout: "check-out",

    // Counter component
    remaining: "REMAINING",
    days: "DAYS",
    hours: "HOURS",
    minutes: "MIN.",
    seconds: "SEC.",
    timeHasCome: "THE TIME HAS COME!",
    confirmByDate: "by July 15th, 2026",

    // ConfirmationContainer component
    confirmTitle: "CONFIRM ATTENDANCE",
    confirmTextLead: "Please confirm your attendance by ",
    deadline: "July 15th, 2026",
    confirmAnother: "Would you like to confirm for another guest?",
    addGuest: "ADD GUEST",

    // ConfirmForm component
    firstName: "First Name*",
    lastName: "Last Name*",
    email: "Email",
    canYouAttend: "Will you be able to attend?*",
    yes: "Yes",
    noSorry: "No, I'm sorry",
    menuChoice: "Menu choice*",
    meatOption: "Meat (chicken)",
    vegOption: "Vegetarian",
    kidsOption: "Kids",
    allergyQuestion: "Do you have any food allergies?",
    allergyYes: "Yes, I do",
    allergyNo: "No",
    allergyFood: "What is the food to avoid?",
    submit: "SUBMIT",
    thankYou: "Thank you for your time.",
    confirmedSuccess: "successfully confirmed attendance at our wedding :) ",
    blackMark: "received a black mark ;/ ",
    alertMissing: "Oops, looks like you forgot to fill something out?",
    alertError:
      "An error occurred. Please try again or contact us to fix it!",
  },
};
